import { settingsService } from './service'
import { createFetchHook } from '../../acato-utils'

export const settingsServiceHooks = createFetchHook(settingsService)
